import { render, staticRenderFns } from "./ExternalPaymentCallback.vue?vue&type=template&id=fc101966&"
import script from "./ExternalPaymentCallback.vue?vue&type=script&lang=ts&"
export * from "./ExternalPaymentCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports